module.exports = __webpack_public_path__ + "static/media/fb-icon.bc54cf60.svg";